module.exports = __webpack_public_path__ + "img/racecourse-kenilworth-turf.808e488d.svg";